export async function sha256(input: string): Promise<string> {
  if (!input) return "";
  if (typeof window === "undefined" || !window.crypto?.subtle) return "";

  const data = new TextEncoder().encode(input);
  const buffer = await window.crypto.subtle.digest("SHA-256", data);

  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
